import { connect, useSelector } from 'react-redux';
import { ButtonIcon, Col, Row } from '@cubeyou-team/hx-react-components';
import React from 'react';
import {
  changeGroupOperatorRequest,
  deleteConversationQueryRequest,
  deleteEntityRequest,
} from '../../../../actions';
import { StyledQueryActionsHeader } from '../QueryActions/StyledQueryActions';
import { QueryOperator } from '../index';
import { findGroupLevel } from '../../../../utils/misc';

const availableOperators = [
  {
    id: 'OR',
    label: 'OR (Any)',
  },
  {
    id: 'AND',
    label: 'AND (All)',
  },
  {
    id: 'NOT (AND)',
    label: 'NOT AND (Exclude)',
  },
];
const ConversationQueryActions = ({
  group,
  index,
  parentGroupId,
  showOperator,
  canDelete,
  changeGroupOperatorRequest,
  deleteEntityRequest,
  deleteConversationQueryRequest,
  onHighlightGroup,
}) => {
  const selectedTargetId = useSelector(
    state => state.queryBuilder.target_selected
  );
  const query = useSelector(
    state => state.queryBuilder.targets[selectedTargetId]
  );
  const level = query && findGroupLevel(query.target_query, group.id, 0);
  const { operator } = group;
  return (
    <StyledQueryActionsHeader>
      <Row halign="between">
        <Col span="auto">
          {showOperator && (
            <QueryOperator
              level={level}
              operator={operator}
              onOperatorChange={operator => {
                changeGroupOperatorRequest(
                  selectedTargetId,
                  group.id,
                  operator
                );
              }}
              onHighlightOperator={onHighlightGroup}
              availableOperators={availableOperators}
            />
          )}
        </Col>
        {canDelete && (
          <Col span="auto">
            <ButtonIcon
              icon="delete"
              size="small"
              type="button"
              variant="dark_lighter"
              onClick={e => {
                e.preventDefault();
                deleteEntityRequest(selectedTargetId, parentGroupId, index);
                deleteConversationQueryRequest(
                  selectedTargetId,
                  parentGroupId,
                  group.id,
                  'group'
                );
                e.stopPropagation();
              }}
            />
          </Col>
        )}
      </Row>
    </StyledQueryActionsHeader>
  );
};

const mapStateToProps = state => ({
  queryBuilder: state.queryBuilder,
});

const mapDispatchToProps = {
  changeGroupOperatorRequest,
  deleteEntityRequest,
  deleteConversationQueryRequest,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ConversationQueryActions);
